import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { title, content, price, unit, features } = plan;

  return (
    <div className="plan-item">

      <h3>{title}</h3> {/* Plan Title */}
      <p>{content}</p> {/* Plan Description */}
      <div className='price'>${price}<span>{unit}</span></div> {/* Plan Price */}

      <Button link={"Get-Quote"} title={"Choose Plan"} />

      {/* List of Features */}
      <ul>
        {features.map((feature, index) => (
          <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
        ))}
      </ul>

    </div>
  );
};

export default Plan;